import { SvgIcons } from "../../../SharedComponents/SvgIcons/SvgIcons";
import styles from "./style.module.css";

export const ErrorText = ({ children }) => (
  <span className={styles.errorText}>
    <SvgIcons name="error_circle_icon" width="16" height="16" className={styles.errorIcon} />
    {children}
  </span>
);

export const WarningText = ({ children }) => (
  <span className={styles.verifyingText}>
    <SvgIcons name="info_circle" width="14" height="14" className={styles.warningIcon} />
    {children}
  </span>
);

export const SuccessText = ({ children }) => (
  <span className={styles.successRow}>
    <SvgIcons name="success_check_circle_icon" width="16" height="16" className={styles.successIcon} />
    <span className={styles.successText}>{children}</span>
  </span>
);
